import { cn } from "@/lib/utils";

export const SIM = "SIMULATED — not sent to the EU";
export const DSTATUS = {
  draft: ["Draft", "bg-slate-100 text-slate-600 border-slate-200", "#94A3B8"],
  blocked: ["Blocked – not DDS ready", "bg-rose-50 text-rose-700 border-rose-200", "#E11D48"],
  invalid: ["Needs attention", "bg-amber-50 text-amber-800 border-amber-200", "#D97706"],
  ready: ["Ready to submit", "bg-sky-50 text-sky-700 border-sky-200", "#0284C7"],
  submitting: ["Submitting", "bg-indigo-50 text-indigo-700 border-indigo-200", "#6366F1"],
  submitted: ["Submitted", "bg-indigo-50 text-indigo-700 border-indigo-200", "#4F46E5"],
  available: ["Available", "bg-emerald-50 text-emerald-700 border-emerald-200", "#059669"],
  rejected: ["Rejected", "bg-rose-50 text-rose-700 border-rose-200", "#BE123C"],
  withdrawn: ["Withdrawn", "bg-slate-100 text-slate-500 border-slate-200", "#64748B"],
};

export function DStatus({ s, testid }) {
  const v = DSTATUS[s] || [s, "bg-slate-100 text-slate-600 border-slate-200"];
  return <span data-testid={testid} className={cn("inline-flex whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide", v[1])}>{v[0]}</span>;
}

export function SimBadge({ show = true, className }) {
  if (!show) return null;
  return <span data-testid="sim-badge" className={cn("inline-flex whitespace-nowrap rounded border border-dashed border-amber-400 bg-amber-50 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-800", className)}>{SIM}</span>;
}

export function DdsRefs({ refs, testid }) {
  if (!refs?.length) return <span className="text-xs text-slate-400">—</span>;
  return (
    <span className="flex flex-col gap-0.5" data-testid={testid}>
      {refs.map((r) => (
        <span key={r.dds_id} className="font-mono text-[11px]">{r.reference_number} · {r.verification_number}{r.mode?.startsWith("SIMULATED") && <span className="ml-1 font-sans text-[9px] font-bold text-amber-700">SIM</span>}</span>
      ))}
    </span>
  );
}
